<template>
  <div class="d-flex flex-row">
    <v-container class="main-container">
      <div class="logo-container">
        <img src="../assets/logo.png" class="logo-img" alt="Netpartar Logo" />
      </div>
      <form action="#" @submit.prevent="signIn">
        <v-row no-gutters class="d-flex align-items-center">
          <v-col>
            <h1 class="label title center">{{ $t('loginPage.signInTitle') }}</h1>
            <p class="desc center">{{ $t('loginPage.signInMessage') }}</p>
          </v-col>
        </v-row>
        <v-row class="pd-default" justify="center" no-gutters>
          <v-col >
            <div class="passwd-top">
              <span class="label text-left">{{ $t('loginPage.emailLabel') }}</span>
            </div>
            <v-text-field
              v-model="email"
              background-color="rgba(224, 231, 255, 0.2)"
              outlined
              dense
              hide-details
              required
              placeholder="staff@netpartar.is"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="pd-default">
          <v-col>
            
            <div class="passwd-top">
              <span class="label text-left">{{ $t('loginPage.passwordLabel') }}</span>
              <!-- <a href="" class="label text-right">{{ $t('loginPage.forgotPassword') }}</a> -->
            </div>
           
            <v-text-field
              v-model="password"
              background-color="rgba(224, 231, 255, 0.2)"
              :append-icon="showpasswd ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showpasswd ? 'text' : 'password'"
              outlined
              dense
              hide-details
              required
              @click:append="showpasswd = !showpasswd"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="pd-default pt-3">
          <v-col>
            <v-btn
              type="submit"
              class="white--text"
              min-height="0"
              height="45px"
              color="#033e8c"
              depressed
              block
              dark
            >
              {{ $t('loginPage.signIn') }}
            </v-btn>
          </v-col>
        </v-row>
        <!--
        <v-row no-gutters class="desc center">
          <span>{{ $t('loginPage.noAccount') }}&nbsp;</span><a href="" class="signup">{{ $t('loginPage.signUp') }}</a>
        </v-row>
        -->
      </form>
      <v-radio-group class="lang-choices" v-model="selectedLang" row>
        <v-radio
          v-for="(lang, i) in langs"
          :key="`Lang${i}`"
          :label="lang.title"
          :value="lang.lang"
        ></v-radio>
      </v-radio-group>
    </v-container>
    <div class="crop">
      <img src="../assets/login-background.jpg" alt="Netpartar Image" />
    </div>
  </div>
</template>

<script>

export default {
  name: "Login",
  components: {},
  data() {
    return {
      showpasswd: false,
      email: '',
      password: '',
      langs: [
        {
          'lang': 'en',
          'title': 'English'
        },
        {
          'lang': 'is',
          'title': 'Íslenska'
        }
      ],
      selectedLang: '',
    }
  },
  methods: {
    signIn() {
      this.$store.dispatch('login', {
        email: this.email,
        password: this.password
      })
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        this.$router.push({ name: 'dashboard'})
      })
      .catch(error => {
        console.log("Failed to login", error)
      }) 
    },
  },
  watch: {
    selectedLang: function (value) {
      this.$i18n.locale = value
      localStorage.setItem('lang', value)
    }
  },
  created() {
    const lang = localStorage.getItem('lang')
    if (lang) {
      this.selectedLang = lang
    } else {
      this.selectedLang = 'is'
    }
  }
}
</script>

<style scoped>

@media screen and (min-width: 415px) {
  .main-container {
    max-width: 355px;
  }
}

.crop {
  display: flex;
  width: 60%;
  height: 100vh;
  overflow: hidden;
}

.crop img{
  height: 100vh;
}

@media screen and (max-width: 1200px) {
  .crop {
    width: 50%;
  }
}

@media screen and (max-width: 1000px) {
  .crop {
    width: 40%;
  }
}

@media screen and (max-width: 768px) {
  .crop {
    width: 30%;
  }
}

@media screen and (max-width: 525px) {
  .crop {
    display: none;
  }
}

.logo-container {
  height: auto;
  width: 100%;
  padding-top: 4.5rem;
  padding-bottom: 3.25rem;
}

.logo-img {
  width: 7.5rem;
  height: 3.75rem;
}

.pd-small {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0.3125rem;
}

.pd-default {
  margin-bottom: 1.1875rem;
}

.passwd-top {
  display: flex;
  justify-content: space-between;
}

.signup {
  color: #116fe4;
  text-decoration: none;
}

</style>
